<template>
  <div class="feedback-grade">
    <button
      class="feedback-grade__button grade-01"
      @click="grade = 1"
    >
      <img src="/static/images/detractor-grade-icon.png">
      <span>PÉSSIMO</span>
    </button>
    <button
      class="feedback-grade__button grade-02"
      @click="grade = 2"
    >
      <img src="/static/images/passive1-grade-icon.png">
      <span>RUIM</span>
    </button>
    <button
      class="feedback-grade__button grade-03"
      @click="grade = 3"
    >
      <img src="/static/images/passive2-grade-icon.png">
      <span>REGULAR</span>
    </button>
    <button
      class="feedback-grade__button grade-04"
      @click="grade = 4"
    >
      <img src="/static/images/promoter1-grade-icon.png">
      <span>BOM</span>
    </button>
    <button
      class="feedback-grade__button grade-05"
      @click="grade = 5"
    >
      <img src="/static/images/promoter2-grade-icon.png">
      <span>EXCELENTE</span>
    </button>
  </div>
</template>

<script>
import mixin from './feedbackMixin'
export default {
  mixins: [mixin],
  data () {
    return {
      grade: null
    }
  },
  watch: {
    grade: function (newValue) {
      this.$emit('update:grade', this.grade)
    },
    isFeedbackModalVisible: function (newValue) {
      this.grade = null
    }
  }
}
</script>

<style lang="scss">
  //feedback variables
  //interface colors
  $inactive-color-border: #d2d2d2;
  $inactive-color-text: #9b9b9b;

  //nps colors
  $detractor-color: #c84a00;
  $passive-color: #efab00;
  $promoter-color: #44ca9e;

  .feedback-grade {
    display: flex;
    flex-grow: 1;
    justify-content: space-evenly;
    align-items: center;
    max-width: 500px;
    margin: 28px 0;

    button::-moz-focus-inner {
      border: 0;
    }

    &__button {
      border: 1px solid $inactive-color-border;
      align-items: center;
      justify-content: center;
      text-align: center;
      border-radius: 6px;
      background: none;
      color: $inactive-color-text;
      padding: 12px 5px;
      margin: 0 5px;
      width: 80px;
      height: 89px;
      font-family: Roboto, sans-serif;
      font-weight: 400;
      font-size: 11px;
      display: block;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      & > img {
        margin-bottom: 6px;
      }
    }

    //detractor grade
    &[grade='1'],
    .grade-01 {
      .grade-01 {
        border-color: $detractor-color;
        color: $detractor-color;
      }

      &:hover {
        border-color: $detractor-color;
        color: $detractor-color;
      }
    }

    //passive grade
    &[grade='2'],
    .grade-02 {
      .grade-02 {
        border-color: $passive-color;
        color: $passive-color;
      }

      &:hover {
        border-color: $passive-color;
        color: $passive-color;
      }
    }

    &[grade='3'],
    .grade-03 {
      .grade-03 {
        border-color: $passive-color;
        color: $passive-color;
      }

      &:hover {
        border-color: $passive-color;
        color: $passive-color;
      }
    }

    //promoter grade
    &[grade='4'],
    .grade-04 {
      .grade-04 {
        border-color: $promoter-color;
        color: $promoter-color;
      }

      &:hover {
        border-color: $promoter-color;
        color: $promoter-color;
      }
    }

    &[grade='5'],
    .grade-05 {
      .grade-05 {
        border-color: $promoter-color;
        color: $promoter-color;
      }

      &:hover {
        border-color: $promoter-color;
        color: $promoter-color;
      }
    }
  }
</style>
